import React from "react";
// import { FooterNav, FooterList, FooterLink } from "@deere/fuel-react";
import { Footer } from "@deere/fuel-react/Footer";
import Link from "@mui/material/Link";

const FooterComponent = () => {
  return (
    <Footer>
      <Link href={"https://jdsn.deere.com"}>{"JDSN Home"}</Link>
      <Link href={"https://www.deere.com/suppliercode"}>
        {"Supplier Code of Conduct"}
      </Link>
      <Link
        href={"https://www.deere.com/en/privacy-and-data/privacy-statements/"}
      >
        {"Privacy & Data"}
      </Link>
      <Link href={"https://www.deere.com/en/privacy-and-data/terms/"}>
        {"Terms of Use"}
      </Link>
    </Footer>
  );
};

export default FooterComponent;
